export default __webpack_public_path__ + "static/media/header.40d62e65.png";